export const NODE_ENV = process.env.REACT_APP_NODE_ENV;
export const RELEASE_HASH = process.env.REACT_APP_RELEASE_HASH;
export const DOCSIE_SCRIPT = process.env.REACT_APP_DOCSIE_SCRIPT || "https://lib.docsie.io/inapp/1.6.0/service.js";

// API Hostnames
export const API_HOSTNAME = process.env.REACT_APP_API_HOSTNAME;
export const NEW_HOST_URL = process.env.REACT_APP_NEW_API_HOSTNAME;
export const PUBLISHER_URL = process.env.REACT_APP_PUBLISHER_API_HOSTNAME;
export const CORE_URL = process.env.REACT_APP_CORE_API_HOSTNAME;
export const AUDIO_CUT_API_HOSTNAME = process.env.REACT_APP_AUDIO_CUT_API_HOSTNAME;
export const CORE_API_HOSTNAME = process.env.REACT_APP_CORE_API_HOSTNAME;
export const DATAFEED_API_HOSTNAME = process.env.REACT_APP_DATAFEED_API_HOSTNAME;
export const ILLUSTO_API_HOSTNAME = process.env.REACT_APP_ILLUSTO_API_HOSTNAME;
export const ILLUSTO_TEMPLATE_API_HOSTNAME = process.env.REACT_APP_ILLUSTO_TEMPLATE_API_HOSTNAME;
export const METADATA_API_HOSTNAME = process.env.REACT_APP_METADATA_API_HOSTNAME;
export const AI_GATEWAY_API_HOSTNAME = process.env.REACT_APP_AI_GATEWAY_API_HOSTNAME;
export const HOSTNAME = process.env.REACT_APP_HOSTNAME;
export const SOCKET_HOSTNAME = process.env.REACT_APP_SOCKET_HOSTNAME;
export const ANALYTICS_HOSTNAME = process.env.REACT_APP_ANALYTICS_HOSTNAME;

export const AES_PASS = process.env.REACT_APP_AES_PASS;
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE;
export const ZEE_PROCESS_VIDEO_THRESHOLD = process.env.ZEE_PROCESS_VIDEO_THRESHOLD || 150;
export const ENABLE_AMPLITUDE = process.env.REACT_APP_ENABLE_AMPLITUDE;
export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

export const E2E_USER_EMAIL = process.env.E2E_USER_EMAIL;
export const E2E_USER_PASSWORD = process.env.E2E_USER_PASSWORD;

export const LAST9_SERVICE_NAME = process.env.REACT_APP_LAST9_SERVICE_NAME;
export const LAST9_ENDPOINT = process.env.REACT_APP_LAST9_ENDPOINT;
export const LAST9_LOGS_ENDPOINT = process.env.REACT_APP_LAST9_LOGS_ENDPOINT;
export const LAST9_API_TOKEN = process.env.REACT_APP_LAST9_API_TOKEN;
export const LAST9_ORIGIN = process.env.REACT_APP_LAST9_ORIGIN || window.location.origin;
export const LAST9_RUM_BASE_URL = process.env.REACT_APP_LAST9_RUM_BASE_URL;

export const LAST9_APP_VERSION = process.env.REACT_APP_LAST9_APP_VERSION;
